import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import Loader from "../../../Components/MainLayout/Loader";
import Header from "../../../Components/MainLayout/Header";
import DatePicker from "react-datepicker";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class NewLeave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Complaint: [],
      formData: {
        school: "",
        name: "",
        phone_no: "",
        complain: "",
        date: new Date(),
      },
      loading: false,
      alertMessage: false,
      leaveType: [],
      one: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Leave";
    this.fetchLeaveType({
      school: this.props.user.user.school.id,
      status: true,
    });
  }

  fetchLeaveType = (params = {}) => {
    axios
      .get("/api/leavetype", { params: { ...params } })
      .then((res) => {
        this.setState({ leaveType: res.data });
      })
      .catch(() => {
        // this.setState({ loading: false });
      });
  };

  handleClick = () => {
    this.setState({ loading: true });
  };

  handleChange = (event) => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let form_data = new FormData();
    const { formData } = this.state;
    // var
    form_data.append("user", this.props.user.user.id);
    form_data.append("school", this.props.user.user.school.id);
    form_data.append("name", this.props.user.user.first_name);
    form_data.append("phone_no", this.props.user.user.sms_number);
    form_data.append("complain", formData.complain);
    form_data.append("status", "true");

    if (this.state.formData.complain) {
      axios
        .post(`/api/complaint`, form_data)
        .then((response) => {
          this.setState({ loading: false });
          this.props.history.push({ pathname: "/prevComplaint" });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false, alertMessage: true });
    }
  };

  changeDate = (e) => {
    this.setState({ date: e });
  };
  render() {
    const { formData } = this.state;
    return (
      <div>
        <Header to="/home" title="Leave" />

        <div className="d-flex flex-row th-no-scroll pt-2">
          <Link style={{ textDecoration: "none" }} to="/prevLeave">
            <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
              <div className="th-black">Previous</div>
            </div>
          </Link>

          <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
            <div className="th-primary">Apply New</div>
            <hr
              className="w-100 my-1 th-border"
              style={{ borderWidth: 5, borderRadius: 5 }}
            />
          </div>
        </div>

        <div className="container">
          <div className="rounded">
            <form onSubmit={this.handleSubmit} autoComplete="off">
              <div className="input-group input-group-sm my-2 shadow-sm">
                <DatePicker
                  placeholderText="Pick Start Date"
                  dateFormat="dd/MM/yyyy"
                  className="form-control th-input-primary th-date th-12"
                  selected={this.state.date}
                  onChange={this.changeDate}
                />
              </div>
              <div className="input-group input-group-sm my-2 shadow-sm">
                <DatePicker
                  placeholderText="Pick End Date"
                  dateFormat="dd/MM/yyyy"
                  className="form-control th-input-primary th-date th-12"
                  selected={this.state.date}
                  onChange={this.changeDate}
                />
              </div>
              <div
                className="input-group input-group shadow-sm my-2"
                onSelect={() => {
                  this.setState({
                    one: document.getElementById("ddlViewBy").value,
                  });
                }}
              >
                <select
                  className="form-control th-input-primary"
                  id="leaveTypeSelect"
                >
                  <option selected>Choose Leave Type</option>
                  {this.state.leaveType?.map((item, index) => {
                    return (
                      <option value="1" key={index}>
                        {item.leave_type}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="input-group input-group shadow-sm">
                <textarea
                  className="form-control th-input-primary"
                  placeholder="Reason for leave"
                  style={{ minHeight: 200 }}
                  name="complain"
                  value={formData.complain}
                  onChange={this.handleChange}
                />
              </div>
              <div className="d-flex justify-content-end py-3">
                {this.state.loading ? (
                  <div className="my-1 pr-2">
                    <Loader />
                  </div>
                ) : null}
                <button
                  onClick={this.handleClick}
                  type="submit"
                  className="th-btn-primary px-4 py-2"
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(NewLeave));
